import React, { useEffect, useState } from "react";
import { getBulkUploadJobsAPI } from "../../../../../api/index";
import "./BulkUploadHistoryModal.css";

const formatDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(
    d.getHours(),
  )}:${pad(d.getMinutes())}`;
};

const BulkUploadHistoryModal = ({ isOpen, onClose, webMemberId, onSelectJob }) => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!isOpen || !webMemberId) return;
    let cancelled = false;

    const load = async () => {
      setLoading(true);
      try {
        const response = await getBulkUploadJobsAPI(webMemberId);
        if (!cancelled) {
          setJobs(response.data || []);
          setError("");
        }
      } catch (err) {
        if (!cancelled) {
          setError(err.response?.data?.msg || "내역을 불러오지 못했습니다.");
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [isOpen, webMemberId]);

  if (!isOpen) return null;

  return (
    <div className="bulkhistorymodal-overlay" onClick={onClose}>
      <div
        className="bulkhistorymodal-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="bulkhistorymodal-header">
          <h2>엑셀 대량등록 내역</h2>
          <button className="bulkhistorymodal-close-btn" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="bulkhistorymodal-body">
          {loading && <p className="bulkhistorymodal-message">불러오는 중...</p>}
          {!loading && error && (
            <p className="bulkhistorymodal-message bulkhistorymodal-error">
              {error}
            </p>
          )}
          {!loading && !error && jobs.length === 0 && (
            <p className="bulkhistorymodal-message">
              아직 엑셀로 등록한 내역이 없습니다.
            </p>
          )}
          {!loading && !error && jobs.length > 0 && (
            <table className="bulkhistorymodal-table">
              <thead>
                <tr>
                  <th>등록일시</th>
                  <th>전체</th>
                  <th>완료</th>
                  <th>대기</th>
                  <th>실패</th>
                  <th>상태</th>
                </tr>
              </thead>
              <tbody>
                {jobs.map((job) => (
                  <tr
                    key={job.job_id}
                    className="bulkhistorymodal-row"
                    onClick={() => onSelectJob(job.job_id)}
                  >
                    <td>{formatDate(job.createdAt)}</td>
                    <td>{job.totalCount}</td>
                    <td className="bulkhistorymodal-success">
                      {job.successCount}
                    </td>
                    <td>{job.pendingCount}</td>
                    <td className="bulkhistorymodal-fail">
                      {job.failCount + (job.rejectedCount || 0)}
                    </td>
                    <td>{job.status === "DONE" ? "완료" : "처리 중"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        <div className="bulkhistorymodal-footer">
          <button className="bulkhistorymodal-close-button" onClick={onClose}>
            닫기
          </button>
        </div>
      </div>
    </div>
  );
};

export default BulkUploadHistoryModal;
